//backup e-mail confirmation
class EmailVerification {

    constructor(email, type) {
        this.email = email;
        this.type = type; //personal/business
    }

    sendConfirmationCode(callback, force = false) {
        if (!force && EmailVerification.prototype.alreadySent[this.email]) {
            console.log('email verification: skipping sendConfirmationCode as already sent for '+this.email);
            callback(true);
            return;
        }

        if (this.type === 'personal') {
            if (this.email === (document.getElementById('username').value + document.getElementById('username-placeholder').innerHTML)) {
                callback(false);
                return;
            }
        }

        $.ajax({
            url: euPortalConfig.euapi_base_uri+'email_verification/?isPersonal='+(this.type === 'personal'),
            type: 'POST',
            data: JSON.stringify({
                email: this.email
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            statusCode: {
                400: function() {
                    console.log('email verification: ajax code verification failed with HTTP 400 ');

                    callback(false); // failed to send email with verification code
                },
                200: function() {
                    callback(true); // email with verification code sent
                }
            },
            headers: {
                'Accept-Language': document.documentElement.lang
            },
            error: function(jqXHR, textStatus, errorThrown ) {
                console.log(['email verification: ajax code verification failed ', this.email, jqXHR, textStatus, errorThrown]);

                callback(false); // code verification failed
            }
        });
    }

    verifyConfirmationCode(verificationCode, callback) {
        $.ajax({
            url: euPortalConfig.euapi_base_uri+'email_verification/'+verificationCode,
            type: 'PUT',
            data: JSON.stringify({
                email: this.email
            }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            statusCode: {
                400: function() {
                    callback(false); // code verification failed
                },
                200: function() {
                    callback(true); // code verification  succeed
                }
            },
            error: function() {
                callback(false); // code verification failed
            }
        });
    }
}

EmailVerification.prototype.alreadySent = {};

export default EmailVerification;
